const statusBar = document.querySelector('.status-bar');
const text = document.querySelector('.status-text');

export const showError = (errorText, top) => {
  statusBar.style.visibility = 'visible';
  statusBar.style.opacity = 1;
  text.innerText = errorText;
  statusBar.style.top = top ? top : '7%';

  setTimeout(() => {
    statusBar.style.visibility = 'hidden';
    statusBar.style.top = '7%';
    statusBar.style.opacity = 0;
    text.innerText = '';
  }, 5000);
};
